import React from 'react';

import {
  BooleanField,
  Datagrid,
  EmailField,
  FilterLiveSearch,
  List,
  NullableBooleanInput,
  NumberField,
  SimpleForm,
  TextField,
} from 'react-admin';

import { CreateDialog } from '@react-admin/ra-form-layout';
import ClientEditBase from './ClientEditBase';

/**
 * People.
 *
 * Reads `clients_unaccent` (the dataProvider rewrites `clients` -> that view on
 * getList), which is now the single list of everyone we know: the funeral world
 * and the lead-capture world merged into one table.
 *
 * That merge is why this list needs a default filter. Roughly half of all rows
 * are people we only ever have a phone number for — someone who called once and
 * left no name. They are real and worth keeping, but showing them first makes
 * the list useless, so the default view is people who have a name and the rest
 * are a facet away.
 */
export const ClientsList = () => (
  <>
    <List
      filters={searchFilters}
      filterDefaultValues={{ is_named: true }}
      hasCreate
      sort={{ field: 'id', order: 'DESC' }}
      perPage={25}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <NumberField source="id" options={{ useGrouping: false }} />
        <TextField source="name" />
        <EmailField source="email" />
        <TextField source="phone_number" />
        <TextField source="city" />
        <BooleanField source="is_linked_to_funeral" label="Case" looseValue />
        <BooleanField source="has_open_lead" label="Open lead" looseValue />
      </Datagrid>
    </List>
    <CreateDialog fullWidth maxWidth="md">
      <SimpleForm>
        <ClientEditBase />
      </SimpleForm>
    </CreateDialog>
  </>
);

// NullableBooleanInput rather than BooleanInput: an unchecked BooleanInput is
// `false`, which filters to people who DON'T match. These need a third state
// meaning "don't filter on this at all".
const searchFilters = [
  <FilterLiveSearch source="unaccent@ilike" alwaysOn />,
  <NullableBooleanInput source="is_named" label="Has a name" />,
  <NullableBooleanInput source="is_linked_to_funeral" label="Linked to a case" />,
  <NullableBooleanInput source="has_open_lead" label="Has an open lead" />,
];
